/**
 * SearchAnalyticsFunction.ts
 * Common analytics functions for search components
 */
import { componentNameConstants, dlEventConstants } from "@repo/analytics/data-layer.constants";
import type { DataLayerProps } from "@repo/analytics/data-layer-utils";
import { trackAnalyticsEvent } from "../../utils/AnalyticsUtils";

/**
 * Handle search back button click analytics
 * Logs click event for the search back button icon
 */
export const handleSearchBackIconClickDL = (
  searchKeyword: string,
  cmp: boolean = false,
  section_title: string,
  position: number = 0
) => {
  const trimmedKeyword = searchKeyword.trim();

  const data: DataLayerProps = {
    component: componentNameConstants.SEARCH_BAR,
    event: "icon",
    event_type: dlEventConstants.CLICK,
    cta_text: trimmedKeyword,
    section_title,
    tab_position: String(position),
    sub_section: "NA",
  };

  trackAnalyticsEvent(data, undefined, "SearchBackIconClick");
};

/**
 * Handle search submit analytics
 * Logs click event for the search submit button
 */
export const handleSearchSubmitDL = (
  searchKeyword: string,
  section_title: string,
  destination_url: string
) => {
  const data: DataLayerProps = {
    component: componentNameConstants.SEARCH_BAR,
    event: "icon",
    event_type: dlEventConstants.CLICK,
    cta_text: searchKeyword,
    section_title,
    destination_url,
    sub_section: "NA",
  };

  trackAnalyticsEvent(data, undefined, "SearchSubmit");
};

/**
 * Handle search suggestion click analytics
 * Logs click event for selecting a search suggestion
 */
export const handleSearchSuggestionClickDL = (
  searchKeyword: string,
  isHistory: boolean,
  sectionTitle: string,
  url: string,
  tabPosition: number = 0
) => {
  const data: DataLayerProps = {
    component: componentNameConstants.SEARCH_BAR,
    event: "tab",
    event_type: dlEventConstants.CLICK,
    cta_text: searchKeyword.trim(),
    section_title: sectionTitle,
    destination_url: url,
    tab_position: String(tabPosition),
    sub_section: "NA",
  };

  trackAnalyticsEvent(data, undefined, "SearchSuggestionClick");
};

/**
 * Handle search history delete icon click analytics
 * Logs click event for deleting a search history item
 */
export const handleSearchHistoryDeleteDL = (
  keyword: string,
  cmp: boolean = false,
  position: number = 0,
  section_title: string
) => {
  const data: DataLayerProps = {
    component: componentNameConstants.SEARCH_BAR,
    event: "icon",
    event_type: dlEventConstants.CLICK,
    cta_text: keyword.trim(),
    section_title,
    tab_position: String(position),
    sub_section: "NA",
  };

  trackAnalyticsEvent(data, undefined, "SearchHistoryDelete");
};
